<div class="container">
  <h3>Add Quote | <em heading-info [quoteInfo]="quoteRequestState"></em></h3>
  <span
    >Product Type: <strong>{{ quoteRequestState?.productType }}</strong></span
  >
  <br />
  <span>Please add and submit your quote below.</span>

  <div [formGroup]="quoteForm">
    <h3>Quote</h3>
    <table class="offer-table table-auto">
      <thead>
        <tr>
          <th id="contractLengthHeader" style="column-width: 250px">
            Contract Length <span style="text-transform: lowercase">(months)</span>
          </th>
          <th id="rateHeader">
            Rate<span style="text-transform: lowercase"> $/{{ getEnergyUnits() }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="inputCell">
            <input
              type="number"
              formControlName="term"
              max="48"
              min="0"
              [class]="quoteForm.get('term').errors && quoteForm.get('term').touched ? 'error' : ''"
            />
          </td>
          <td class="inputCell">
            <input
              type="number"
              formControlName="rate"
              [class]="quoteForm.get('rate').errors && quoteForm.get('rate').touched ? 'error' : ''"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <p class="error" *ngIf="quoteForm.get('term').errors && quoteForm.get('term').touched">Please enter a valid term</p>
    <p class="error" *ngIf="quoteForm.get('rate').errors && quoteForm.get('rate').touched">Please enter a valid rate</p>
  </div>
</div>
